import Vue from 'vue';
import Vuex from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Layout from '../modules/layout/store';
import Account from '../modules/account/store';
import Dashboard from '../modules/dashboard/store';
import Errors from '../modules/errors/store';
import Config from '../modules/config/store';
import User from '../modules/user/store';

Vue.use(Vuex);

export function GetStore() {
  return cloneDeep({
    modules: {
      account: Account,
      dashboard: Dashboard,
      errors: Errors,
      layout: Layout,
      config: Config,
      user: User,
    },
  });
}

export default new Vuex.Store(GetStore());
